import React, { useEffect, useState } from "react";
import { CalendarClock, X } from "lucide-react";
import { aiApi, formatApiError } from "../../lib/ledgerApi";
import { toast } from "sonner";

const fmt = (s) => {
  try {
    const n = Number(s);
    return Number.isFinite(n) ? n.toLocaleString(undefined, { maximumFractionDigits: 6 }) : s;
  } catch {
    return s;
  }
};

export default function Scheduled() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setItems(await aiApi.myScheduled());
    } catch (e) {
      toast.error("Failed", { description: formatApiError(e.response?.data?.detail) });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    const i = setInterval(load, 5000);
    return () => clearInterval(i);
  }, []);

  const onCancel = async (id) => {
    try {
      await aiApi.cancelScheduled(id);
      toast.success("Cancelled");
      await load();
    } catch (e) {
      toast.error("Cancel failed", { description: formatApiError(e.response?.data?.detail) });
    }
  };

  return (
    <div className="max-w-5xl px-6 md:px-10 py-10 md:py-14" data-testid="scheduled-page">
      <div className="mb-8">
        <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-3">/ AI · Scheduled</div>
        <h1 className="text-3xl sm:text-4xl tracking-tight font-medium flex items-center gap-3">
          <CalendarClock className="w-6 h-6 text-muted-foreground" strokeWidth={1.5} /> Scheduled transfers
        </h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Future-dated transfers parsed from natural language. Risk &amp; compliance run when each one fires.
        </p>
      </div>

      {loading && <div className="text-sm text-muted-foreground">Loading…</div>}
      {!loading && items.length === 0 && (
        <div className="border border-border rounded-sm bg-card p-8 text-center text-muted-foreground text-sm">
          No upcoming transfers. Try “send 100 USD to globex@neopay tomorrow at 9am” in the Send screen.
        </div>
      )}

      <div className="space-y-3">
        {items.map((s) => (
          <div
            key={s.id}
            data-testid={`scheduled-${s.id}`}
            className="border border-border rounded-sm bg-card p-5 flex items-center justify-between gap-4"
          >
            <div>
              <div className="text-lg">
                <span className="font-mono">{fmt(s.amount)} {s.currency}</span>{" "}
                <span className="text-muted-foreground">→ {s.to_vpa}</span>
              </div>
              {s.memo && <div className="text-[12px] text-muted-foreground mt-1">“{s.memo}”</div>}
              <div className="text-[11px] font-mono text-muted-foreground mt-1">
                fires {new Date(s.execute_at).toLocaleString()}
              </div>
            </div>
            <button
              onClick={() => onCancel(s.id)}
              data-testid={`scheduled-cancel-${s.id}`}
              className="inline-flex items-center gap-1.5 px-3 py-2 text-xs border border-border rounded-sm hover:border-status-tampered hover:text-status-tampered transition-colors"
            >
              <X className="w-3 h-3" strokeWidth={1.5} /> Cancel
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
